module.exports = __webpack_public_path__ + "img/lesser_wind_elemental_small.00f4c3f4.png";